import { useNavigate as useRouterNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { PreloadChannels } from 'core/constants/enums/PreloadChannels.ts';
import { RENDERNET_PRICING_URL } from 'core/constants/constants';

const useCustomNavigate = () => {
	const navigate = useRouterNavigate();

	return useCallback(
		(to, options = {}) => {
			if (typeof to !== 'string' && typeof to !== 'number') {
				return;
			}

			if (window.electron && to.includes('pricing')) {
				window.electron.ipcRenderer.send(PreloadChannels.OPEN_EXTERNAL_LINK, RENDERNET_PRICING_URL);
				return;
			}

			navigate(to, options);
		},
		[navigate],
	);
};

export default useCustomNavigate;
